var cell_default = {
  "cell": "Dpcsk",
  "header": "_7Tiam",
  "selected": "OFd3Q",
  "editing": "fuYTc",
  "singleSelection": "aMpCd",
  "hideLastBlock": "hyIUD",
  "editorWrapper": "zgqhO",
  "viewerWrapper": "EbDTX",
  "hideFirstBlock": "YrWfD",
  "editor": "nkwmY",
  "edit": "Wonns",
  "view": "_3SpeB",
  "editingToolbarWrapper": "I2aWZ",
  "selectAll": "sdc2h",
  "disableSelection": "_9eARB"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
